
import { useState } from "react";
import { connect } from "react-redux";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";

import CustomInput from "../../../common/CustomInput";
import CustomDatePickerV2 from "../../../common/CustomDatePickerV2";
import CustomButton from "../../../common/CustomButton";
import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";

import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";
import PersonalInfoPostMessage from "./PersonalInfoPostMessage";

function PersonalInfo(props) {

    const [personalInfo, setPersonalInfo] = useState({
        firstName: "",
        lastName: "",
        gender: "",
        dob: "",
        inputEmail: "",
    });

    const genderArray = ["Male", "Female", "Gender not listed", "Prefer not to say"];
    const genderValue = {
        "Male": "M",
        "Female": "F",
        "Gender not listed": "GNL",
        "Prefer not to say": "PNTS",
    };
    const genderKey = {
        M: "Male",
        F: "Female",
        GNL: "Gender not listed",
        PNTS: "Prefer not to say",
    };

    const updatePersonalInfo = (e) => {
        const { name, value } = e.target;

        setPersonalInfo({
            ...personalInfo,
            [name]: name == "gender" ? genderValue[value] : value,
        });
    }

    const handleContinue = () => {
        props.SetModalProperties({
            title: "",
            isShow: true,
            showCloseButton: false,
            height: "calc(100% - 60px)",
            bgColor: "transparent",
            body: (
                <PersonalInfoPostMessage moveNext={() => {
                    props.ShowModal(false);
                    props.moveNext();
                }} />
            ),
            actions: [],
        });
    }

    let disable = personalInfo?.firstName === "" || personalInfo?.lastName === "" || personalInfo?.dob === "" || personalInfo?.gender === "";

    return (
        <div id="uo-personal-info" className="uo-component div-45-55">
            <div id="uo-pi-banner">
                {/* <svg id="uo-pi-polygon" width="1017" height="100%" viewBox="0 0 1017 618" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M984.705 0.938281C1015.01 0.642782 1027.69 39.5371 1003.03 57.159L227.556 611.299C210.514 623.477 186.55 615.599 180.059 595.684L2.46146 50.8365C-4.02984 30.9219 10.6882 10.435 31.633 10.2307L984.705 0.938281Z" fill="url(#paint0_linear_58_106)" />
                    <defs>
                        <linearGradient id="paint0_linear_58_106" x1="304.192" y1="-145.479" x2="539.52" y2="576.479" gradientUnits="userSpaceOnUse">
                            <stop offset="1" stop-color="#8B1E3F" />
                        </linearGradient>
                    </defs>
                </svg> */}

                <img src="/assets/images/onboarding/profile-info-banner.png" className="pi-banner" />
            </div>
            <div id="uo-pi-inputs" className="ou-with-text">
                <h4>Let’s Get to Know Each Other</h4>
                <div id="uo-pi-inputs-wrapper">
                    {/* 
                        // HONEYPOT
                    */}
                    <div
                        className="d-sm-flex align-items-center" //HONEY-P
                        style={{
                            position: "absolute",
                            top: "-99999px",
                        }}
                    >
                        <CustomInput
                            type="text"
                            placeholder="Email"
                            className="form-control i-box"
                            value={""}
                            name="inputEmail"
                            onChange={(e) => {
                            }}
                            onBlur={(e) => {
                            }}
                        />
                    </div>

                    <CustomInput
                        type="text"
                        placeholder="First Name"
                        className="form-control i-box"
                        value={personalInfo?.firstName}
                        name="firstName"
                        onChange={updatePersonalInfo}
                        onBlur={(e) => {
                        }}
                    />

                    <CustomInput
                        type="text"
                        placeholder="Last Name"
                        className="form-control i-box"
                        value={personalInfo?.lastName}
                        name="lastName"
                        onChange={updatePersonalInfo}
                        onBlur={(e) => {
                        }}
                    />


                    <div className="input-field">
                        <DropDownListComponent
                            onBlur={(e) => { }}
                            value={personalInfo?.gender}
                            dataSource={genderArray}
                            placeholder="Gender"
                            className="field"
                            onChange={(e) => {
                                updatePersonalInfo({
                                    target: {
                                        value: e.value,
                                        name: "gender",
                                    },
                                });
                            }}
                        />
                    </div>

                    <div className="input-field date-picker">
                        <CustomDatePickerV2
                            withCustomModal={false}
                            value={personalInfo?.dob}
                            onChange={(e) => {
                                updatePersonalInfo({
                                    target: {
                                        value: e,
                                        name: "dob",
                                    },
                                });
                            }}
                        />
                    </div>

                    <CustomButton disabled={disable} className="uo-button active" onClick={() => {
                        props.moveNext();
                        props.setPreRegistrationDetails(prd => ({
                            ...prd,
                            personalInfo: personalInfo,
                        }))
                    }}>Continue</CustomButton>
                    {/* <CustomButton className="active" onClick={handleContinue}>Continue</CustomButton> */}

                </div>
            </div>


        </div >
    );
}

const mapStateToProps = (state) => ({

});

export default connect(mapStateToProps, {
    SetModalProperties,
    ShowModal,
})(PersonalInfo);
